var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable */
import { AxiosError } from 'axios';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { FormContext } from '../../../common/context/context';
import { ApiI18, getResponseErrorMessage } from '../../../network/api';
import { FormContainer, FlexWrapContainer, ChildContainer, LeftAlignedComponent, RightAlignedComponent, HorizontalLine, ErrorWrapperOutInput } from '../../../styles/generalStyles';
import { TitleForm, TextInLine } from '../../../styles/variables/text.styles';
import { phoneNumber } from '../../../util/validation';
import { Button } from "../../_common/button/button.styles";
import CheckBox from '../../_common/checkbox/checkbox';
import { TextCheckBox } from '../../_common/checkbox/checkbox.styles';
import DropdownInput from "../../_common/dropdown/dropdown";
import Input from "../../_common/input/input";
import LangMessage from "../../_common/lang/message";
import InputRadio from "../../_common/radio/radio";
import { regFormData } from './registration.data';
import { regFormDataValid, validateEmail } from '../../../util/form.validation';
import useAutofillForm from '../../../hooks/useAutofillForm';
var initialGeneralInfoState = {
    companyName: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    website: '',
};
var FormRegistration = function (_a) {
    var showSuccessScreen = _a.showSuccessScreen;
    var state = React.useContext(FormContext).state;
    var _b = useState(initialGeneralInfoState), generalUserInfo = _b[0], setGeneralUserInfo = _b[1];
    var _c = useState('Car'), role = _c[0], setRole = _c[1];
    var _d = useState(false), isCheckboxChecked = _d[0], setIsCheckboxChecked = _d[1];
    var _e = useState(''), isCheckboxCheckedError = _e[0], setIsCheckboxCheckedError = _e[1];
    var _f = useState(undefined), error = _f[0], setError = _f[1];
    var _g = useState(''), emailError = _g[0], setEmailError = _g[1];
    var _h = useState(''), phoneError = _h[0], setPhoneError = _h[1];
    var _j = useState({}), requiredFieldErrors = _j[0], setRequiredFieldErrors = _j[1];
    var captchaRef = useRef(null);
    var _k = React.useState(false), isValidCaptcha = _k[0], setCaptchaValid = _k[1];
    var handleClearError = function (fieldName) {
        setRequiredFieldErrors(function (prevErrors) {
            var _a;
            return (__assign(__assign({}, prevErrors), (_a = {}, _a[fieldName] = '', _a)));
        });
    };
    var _l = useAutofillForm(handleClearError), address = _l.address, setAddress = _l.setAddress, getAddressPart = _l.getAddressPart, selectedCountry = _l.selectedCountry, isCountryInputUserTyped = _l.isCountryInputUserTyped, setCountryError = _l.setCountryError, countryInputValue = _l.countryInputValue, handleAddressChange = _l.handleAddressChange, handleSelectedValueChange = _l.handleSelectedValueChange, predictions = _l.predictions, countryError = _l.countryError, handleCountryChange = _l.handleCountryChange, handleInputClickDropdownVisible = _l.handleInputClickDropdownVisible, handleSelectedCountry = _l.handleSelectedCountry, filteredCountries = _l.filteredCountries, setCountryInputValue = _l.setCountryInputValue, addressInputValue = _l.addressInputValue, setAddressInputValue = _l.setAddressInputValue;
    var handleGeneralUserInfo = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        var phoneValidationResult = '';
        var emailValidationResult = '';
        if (name === 'phone') {
            phoneValidationResult = phoneNumber(value) ? '' : 'CustDashboard.form.numberPhone';
            if (phoneError !== '') {
                setPhoneError(phoneValidationResult);
            }
        }
        if (name === 'email' && emailError !== '') {
            emailValidationResult = validateEmail(value, setEmailError) ? '' : 'CustDashboard.invalidEmailAddress';
            setEmailError(emailValidationResult);
            setError(emailValidationResult);
        }
        setGeneralUserInfo(__assign(__assign({}, generalUserInfo), (_a = {}, _a[name] = value, _a)));
        handleClearError(name);
    };
    var handleAddressUserInfo = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setAddress(__assign(__assign({}, address), (_a = {}, _a[name] = value, _a)));
        handleClearError(name);
    };
    var onCaptchaChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var recaptcha, success, res, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(captchaRef === null || captchaRef === void 0 ? void 0 : captchaRef.current)) return [3 /*break*/, 5];
                    recaptcha = captchaRef.current.getValue();
                    captchaRef.current.reset();
                    if (!recaptcha) return [3 /*break*/, 5];
                    success = false;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiI18.verifyCaptcha({ recaptcha: recaptcha })];
                case 2:
                    res = _a.sent();
                    success = res.data.payload;
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (error_1 instanceof AxiosError) {
                        message = getResponseErrorMessage(error_1);
                        setError(message);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    setCaptchaValid(success);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var scrollToErrorInput = function () {
        var errorInput = document.querySelector('.error');
        if (errorInput) {
            errorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    var handleSignUp = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiI18.signUpUser(data)];
                case 1:
                    response = _a.sent();
                    if (response.status >= 200 && response.status < 300) {
                        if (showSuccessScreen) {
                            showSuccessScreen();
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    if (error_2 instanceof AxiosError) {
                        message = getResponseErrorMessage(error_2);
                        setError(message);
                        scrollToErrorInput();
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSignUpClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasErrors, _loop_1, _i, _a, field, country, trimmedPhoneNumber, allFormValues, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    hasErrors = false;
                    _loop_1 = function (field) {
                        var value = generalUserInfo[field.name];
                        if (field.required && !value) {
                            hasErrors = true;
                            setRequiredFieldErrors(function (prevErrors) {
                                var _a;
                                return (__assign(__assign({}, prevErrors), (_a = {}, _a[field.name] = 'CustDashboard.required', _a)));
                            });
                        }
                        if ((field.name === 'email' && emailError !== '') || (field.name === 'phone' && phoneError !== '')) {
                            hasErrors = true;
                            if (field.name === 'phone') {
                                setPhoneError('CustDashboard.form.numberPhone');
                            }
                            if (field.name === 'email') {
                                setEmailError('CustDashboard.form.invalidEmail');
                            }
                        }
                    };
                    for (_i = 0, _a = regFormData.regGeneralInfoFields; _i < _a.length; _i++) {
                        field = _a[_i];
                        _loop_1(field);
                    }
                    if (!selectedCountry && !isCountryInputUserTyped && !getAddressPart('country')) {
                        hasErrors = true;
                        setCountryError('CustDashboard.required');
                    }
                    regFormData.regAddressFields.forEach(function (field) {
                        var value = getAddressPart(field.id);
                        if (!value) {
                            hasErrors = true;
                            setRequiredFieldErrors(function (prevErrors) {
                                var _a;
                                return (__assign(__assign({}, prevErrors), (_a = {}, _a[field.id] = 'CustDashboard.required', _a)));
                            });
                        }
                    });
                    if (!isCheckboxChecked) {
                        hasErrors = true;
                        setIsCheckboxCheckedError('CustDashboard.form.acceptTermsConditions');
                    }
                    if (hasErrors) {
                        setTimeout(function () {
                            scrollToErrorInput();
                        }, 1000);
                        return [2 /*return*/];
                    }
                    country = selectedCountry || countryInputValue || getAddressPart('country');
                    trimmedPhoneNumber = generalUserInfo.phone ? generalUserInfo.phone.replace(/\s+/g, '').trim() : '';
                    allFormValues = __assign(__assign(__assign(__assign({}, generalUserInfo), { phone: trimmedPhoneNumber }), address), { bexioCurrencyId: country === 'Switzerland' ? 1 : 2, company: generalUserInfo.companyName, country: country, currency: country === 'Switzerland' ? 'CHF' : 'EUR', isDemo: true, isPro: ['Car and Moto Dealer', 'Moto'].includes(role), lang: state.lang, role: "5caaef1a1d50f8270cdd75d5", showMoto: ['Car and Moto Dealer', 'Moto'].includes(role), zip: address.zipCode });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    if (!(generalUserInfo.phone.trim() !== '')) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleSignUp(allFormValues)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setPhoneError('CustDashboard.form.numberPhone');
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_3 = _b.sent();
                    setError(error_3.message);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var dropdownAddressProps = {
        icon: true,
        inputValue: addressInputValue,
        label: 'formReg.address',
        maxResults: 5,
        onChange: handleAddressChange,
        onSelect: handleSelectedValueChange,
        options: predictions,
        placeholder: 'formReg.phldr.address',
        required: false,
        setInputValue: setAddressInputValue,
        showOptions: true
    };
    var dropdownCountriesProps = {
        errorMessage: countryError,
        icon: false,
        inputValue: selectedCountry || isCountryInputUserTyped ? countryInputValue : getAddressPart('country'),
        label: 'formReg.country',
        onChange: handleCountryChange,
        onClick: handleInputClickDropdownVisible,
        onSelect: handleSelectedCountry,
        options: filteredCountries,
        placeholder: 'formReg.phldr.country',
        required: true,
        setInputValue: setCountryInputValue,
        showOptions: true
    };
    var handleCheckEmail = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiI18.checkEmail(data)];
                case 1:
                    response = _a.sent();
                    if (response.status >= 200 && response.status < 300) {
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    if (error_4 instanceof AxiosError) {
                        message = getResponseErrorMessage(error_4);
                        setError(message);
                    }
                    setCaptchaValid(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleEmailBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValidEmail, error_5, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError('');
                    setEmailError('');
                    isValidEmail = validateEmail(generalUserInfo.email, setEmailError);
                    if (!(isValidEmail && generalUserInfo.email)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleCheckEmail({ email: generalUserInfo.email })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    if (error_5 instanceof AxiosError) {
                        message = getResponseErrorMessage(error_5);
                        setError(message);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handlePhoneBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValidPhone;
        return __generator(this, function (_a) {
            setError('');
            setPhoneError('');
            isValidPhone = phoneNumber(generalUserInfo.phone);
            if (isValidPhone) {
                setPhoneError('');
                setError('');
            }
            else {
                if (!isValidPhone && generalUserInfo.phone.trim() !== '') {
                    setPhoneError('CustDashboard.form.numberPhone');
                }
            }
            return [2 /*return*/];
        });
    }); };
    var handleCheckBoxChange = function (isChecked) {
        setIsCheckboxChecked(function (prevIsChecked) {
            if (!prevIsChecked && isChecked) {
                setIsCheckboxCheckedError('');
            }
            return isChecked;
        });
    };
    return (_jsx("form", { children: _jsxs(FormContainer, { children: [_jsx(TitleForm, { children: _jsx(LangMessage, { msgKey: "formReg.createAccount" }) }), _jsxs(FlexWrapContainer, { children: [regFormData.regGeneralInfoFields.map(function (field, index) { return (_jsx(ChildContainer, { children: _jsx(Input, __assign({}, field, { value: generalUserInfo[field.name], onChange: handleGeneralUserInfo, errorMessage: (field.name === 'email'
                                    ? emailError || error || requiredFieldErrors[field.name]
                                    : requiredFieldErrors[field.name] || regFormDataValid(field, generalUserInfo))
                                    || (field.name === 'phone' ? phoneError : ''), errorMessageWithoutTrans: field.name === 'email' ? error : '', onBlur: (field.name === 'email' ? handleEmailBlur : undefined) || (field.name === 'phone' ? handlePhoneBlur : undefined), autoComplete: "off", handleClearInput: function () {
                                    var _a;
                                    var clearedState = __assign(__assign({}, generalUserInfo), (_a = {}, _a[field.name] = '', _a));
                                    setGeneralUserInfo(clearedState);
                                    setPhoneError('');
                                } })) }, index)); }), _jsx("div", __assign({ style: { width: '100%' } }, { children: _jsx(DropdownInput, __assign({}, dropdownAddressProps)) })), _jsx(ChildContainer, { children: _jsx(DropdownInput, __assign({}, dropdownCountriesProps)) }), regFormData.regAddressFields.map(function (field, index) { return (_jsx(ChildContainer, { children: _jsx(Input, __assign({}, field, { errorMessage: requiredFieldErrors[field.name], value: getAddressPart(field.id), onChange: handleAddressUserInfo, handleClearInput: function () {
                                    var _a;
                                    var clearedAddressState = __assign(__assign({}, address), (_a = {}, _a[field.name] = '', _a));
                                    setAddress(clearedAddressState);
                                } })) }, index)); }), _jsxs(LeftAlignedComponent, { children: [_jsx(HorizontalLine, {}), _jsx(TextInLine, { children: _jsx(LangMessage, { msgKey: "formReg.youAre" }) }), _jsx(HorizontalLine, {})] }), regFormData.regRadioInfoFields.map(function (field, index) { return (_jsx(ChildContainer, __assign({ "$marginBottom": '10px' }, { children: _jsx(InputRadio, __assign({}, field, { value: field.value, checked: role === field.value, onChange: function () {
                                    setRole(field.value);
                                } })) }), index)); }), _jsx(LeftAlignedComponent, __assign({ "$paddingTop": '10px' }, { children: _jsx(CheckBox, __assign({ disabled: false, isChecked: isCheckboxChecked, setIsChecked: handleCheckBoxChange }, { children: _jsxs(TextCheckBox, { children: [_jsx(LangMessage, { msgKey: "formReg.agrmt.beforeLink " }), _jsxs("a", __assign({ href: 'https://pixel24.world/en/terms-and-conditions/', target: "_blank" }, { children: [' ', _jsx(LangMessage, { msgKey: "formReg.agrmt.linkText.license" })] })), ",", _jsxs("a", __assign({ href: 'https://pixel24.world/en/datenschutz/', target: "_blank" }, { children: [' ', _jsx(LangMessage, { msgKey: "formReg.agrmt.linkText.privacy" }), " "] })), _jsx(LangMessage, { msgKey: "formReg.agrmt.afterLink" }), " "] }) })) })), _jsx(LeftAlignedComponent, { children: isCheckboxCheckedError && _jsx(ErrorWrapperOutInput, { children: _jsx(LangMessage, { msgKey: 'CustDashboard.form.acceptTermsConditions' }) }) }), _jsxs(RightAlignedComponent, __assign({ "$paddingBottom": '20px', "$paddingTop": '40px' }, { children: [!isValidCaptcha && (_jsx(ReCAPTCHA, { sitekey: process.env.REACT_APP_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", ref: captchaRef, onChange: onCaptchaChange, style: { alignSelf: "center", paddingTop: "20px" } })), isValidCaptcha && (_jsx(Button, __assign({ "$bgColour": 'blue', "$size": 'large', type: 'button', onClick: handleSignUpClick }, { children: _jsx(LangMessage, { msgKey: "formReg.submitAccount" }) })))] }))] })] }) }));
};
export default FormRegistration;
